
import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaEnvelope, FaArrowLeft, FaCheckCircle } from 'react-icons/fa';
import { requestPasswordReset } from '../services/authService';

const ForgotPasswordPage = () => {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const result = await requestPasswordReset(email);

            if (result.success) {
                setSuccess(true);
            } else {
                setError(result.message || 'Bir hata oluştu');
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Sunucu hatası oluştu');
        } finally {
            setLoading(false);
        }
    };

    if (success) {
        return (
            <div className="forgot-password-page">
                <section className="py-5">
                    <Container>
                        <div className="text-center mb-5">
                            <h1 className="section-title">Email Gönderildi</h1>
                        </div>
                    </Container>
                </section>

                <section className="py-5 bg-light">
                    <Container>
                        <Row className="justify-content-center">
                            <Col xs={12} md={6} lg={5}>
                                <div className="modern-faq-item text-center">
                                    <div className="advantage-icon-modern mb-4" style={{ color: 'var(--success-color)' }}>
                                        <FaCheckCircle />
                                    </div>

                                    <h3 className="modern-faq-question mb-4">Email Başarıyla Gönderildi!</h3>

                                    <div className="modern-faq-answer">
                                        <p className="mb-4">
                                            <strong>{email}</strong> adresine şifre sıfırlama bağlantısı gönderildi.
                                        </p>
                                        <p className="mb-4">
                                            Email'inizi kontrol edin ve bağlantıya tıklayarak yeni şifrenizi oluşturun.
                                        </p>
                                        <p className="text-muted small">
                                            Email gelmezse spam klasörünüzü kontrol edin. Bağlantı 1 saat geçerlidir.
                                        </p>
                                    </div>

                                    <div className="mt-4">
                                        <Link to="/login" className="btn apply-btn-black">
                                            <FaArrowLeft className="me-2" />
                                            Giriş Sayfasına Dön
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        );
    }

    return (
        <div className="forgot-password-page">
            <section className="py-5">
                <Container>
                    <div className="text-center mb-5">
                        <h1 className="section-title">Şifremi Unuttum</h1>
                        <p className="lead">Email adresinizi girin, size şifre sıfırlama bağlantısı gönderelim</p>
                    </div>
                </Container>
            </section>

            <section className="py-5 bg-light">
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} md={6} lg={5}>
                            <div className="modern-faq-item">
                                <div className="text-center mb-4">
                                    <div className="advantage-icon-modern mb-3">
                                        <FaEnvelope />
                                    </div>
                                    <h3 className="modern-faq-question">Email Adresinizi Girin</h3>
                                </div>

                                {error && (
                                    <Alert variant="danger" className="mb-4">
                                        {error}
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-4" controlId="email">
                                        <Form.Label>
                                            <FaEnvelope className="me-2" />
                                            Email Adresi
                                        </Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Kayıtlı email adresinizi girin"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            className="py-3"
                                        />
                                        <Form.Text className="text-muted">
                                            Bu email adresine şifre sıfırlama bağlantısı göndereceğiz.
                                        </Form.Text>
                                    </Form.Group>

                                    <Button
                                        type="submit"
                                        className="apply-btn-black w-100 py-3 mb-4"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                Gönderiliyor...
                                            </>
                                        ) : (
                                            <>
                                                <FaEnvelope className="me-2" />
                                                Sıfırlama Bağlantısı Gönder
                                            </>
                                        )}
                                    </Button>

                                    <div className="text-center">
                                        <Link to="/login" className="text-decoration-none" style={{ color: 'var(--black)' }}>
                                            <FaArrowLeft className="me-2" />
                                            Giriş sayfasına dön
                                        </Link>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default ForgotPasswordPage;
